import { createBrowserRouter } from "react-router-dom";
import DashboardLayout from "../../Layout/DashboardLayout";
import Main from "../../Layout/Main";
import About from "../../Pages/About/About";
import Apply from "../../Pages/Apply/Apply";
import Blog from "../../Pages/Blog/Blog";
import SingleBlogPost from "../../Pages/Blog/SingleBlogPost";
import CashBackLanding from "../../Pages/CashBackLanding/CashBackLanding";
import CashBackLandingForDeals from "../../Pages/CashBackLanding/CashBackLandingForDeals";
import CategorizedProducts from "../../Pages/CategorizedProducts/CategorizedProducts";
import ClaimCashback from "../../Pages/ClaimCashBack/ClaimCashBack";
import DetailsClaimCashBack from "../../Pages/ClaimCashBack/DetailsClaimCashBack";
import CategorizedCoupon from "../../Pages/Coupons/CategorizedCoupon";
import Coupon from "../../Pages/Coupons/Coupon";
import CouponPage from "../../Pages/Coupons/CouponPage";
import Coupons from "../../Pages/Coupons/Coupons";
import Affiliation from "../../Pages/Dashboard/Affiliation/Affiliation";
import Appointment from "../../Pages/Dashboard/Appointment/Appointment";
import Dashboard from "../../Pages/Dashboard/Dashboard/Dashboard";
import Disputes from "../../Pages/Dashboard/Disputes/Disputes";
import EditProfile from "../../Pages/Dashboard/EditProfile/EditProfile";
import PurchasedItems from "../../Pages/Dashboard/PurchasedItems/PurchasedItems";
import ResetPassword from "../../Pages/Dashboard/ResetPassword/ResetPassword";
import Tickets from "../../Pages/Dashboard/Ticket/Tickets";
import Withdraw from "../../Pages/Dashboard/Withdraw/Withdraw";
import EmailPreferences from "../../Pages/EmailPreferences/EmailPreferences";
import Home from "../../Pages/Home/Home/Home";
import SingleTopDeal from "../../Pages/Home/TopDeals/SingleTopDeal";
import TopDeals from "../../Pages/Home/TopDeals/TopDeals";
import Job from "../../Pages/Job/Job";
import UserLogin from "../../Pages/Login/UserLogin";
import Merchant from "../../Pages/Merchant/Merchant";
import Press from "../../Pages/Press/Press";
import Referral from "../../Pages/Referral/Referral";
import AdvertisementDisclosure from "../../Pages/Shared/Footer/AdvertisementDisclosure";
import AppPolicy from "../../Pages/Shared/Footer/AppPolicy";
import CookiePolicy from "../../Pages/Shared/Footer/CookiePolicy";
import PrivacyPolicy from "../../Pages/Shared/Footer/PrivacyPolicy";
import ReferralPolicy from "../../Pages/Shared/Footer/ReferralPolicy";
import Terms from "../../Pages/Shared/Footer/Terms";
import Contact from "../../Pages/Shared/Help/Contact/Contact";
import FAQ from "../../Pages/Shared/Help/FAQ/FAQ";
import HelpHome from "../../Pages/Shared/Help/HelpHome/HelpHome";
import Shop from "../../Pages/Shop/Shop";
import UserSignup from "../../Pages/Signup/UserSignup";
import DetailsWhatsNew from "../../Pages/WhatsNew/DetailsWhatsNew";
import WhatsNew from "../../Pages/WhatsNew/WhatsNew";
import PrivateRoute from "../PrivateRoute/PrivateRoute";

const router = createBrowserRouter([
    {
      path: "/",
      element: <Main></Main>,
      children: [
        {
          path: "/",
          element: <Home></Home>,
        },
        {
          path: "/coupons",
          element: <Coupons></Coupons>,
        },
        {
          path: "/coupon/:id",
          element: <Coupon></Coupon>,
        },
        {
          path: "/coupon-page",
          element: <CouponPage></CouponPage>,
        },
        {
          path: "/coupon-page/:name",
          element: <CategorizedCoupon></CategorizedCoupon>,
        },
        {
          path: "/products/:name",
          element: <CategorizedProducts></CategorizedProducts>,
        },
        {
          path: "/merchant/:name",
          element: <Merchant></Merchant>,
        },
        {
          path: "/blog",
          element: <Blog></Blog>,
        },
        {
          path: "/blog/:slug",
          element: <SingleBlogPost></SingleBlogPost>,
        },
        {
          path: "/login",
          element: <UserLogin></UserLogin>,
        },
        {
          path: "/signup",
          element: <UserSignup></UserSignup>,
        },
        {
          path: "/terms",
          element: <Terms></Terms>,
        },
        {
          path: "/top-deals",
          element: <TopDeals></TopDeals>,
        },
        {
          path: "/top-deals/:id",
          element: <SingleTopDeal></SingleTopDeal>,
        },
        {
          path: "/products/:id",
          element: <SingleTopDeal></SingleTopDeal>,
        },
        {
          path: "/shop",
          element: <Shop></Shop>,
        },
        {
          path: "/faq",
          element: <FAQ></FAQ>,
        },
        {
          path: "/referral",
          element: <Referral></Referral>,
        },
        {
          path: "/help",
          element: <HelpHome></HelpHome>,
        },
        {
          path: "/contact",
          element: <Contact></Contact>,
        },
        {
          path: "/email-preferences",
          element: <EmailPreferences></EmailPreferences>,
        },
        {
          path: "/job",
          element: <Job></Job>,
        },
        {
          path: "/press",
          element: <Press></Press>,
        },
        {
          path: "/about",
          element: <About></About>,
        },
        {
          path: "/apply",
          element: <Apply></Apply>,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicy></PrivacyPolicy>,
        },
        {
          path: "/cookie-policy",
          element: <CookiePolicy></CookiePolicy>,
        },
        {
          path: "/referral-policy",
          element: <ReferralPolicy></ReferralPolicy>,
        },
        {
          path: "/app-policy",
          element: <AppPolicy></AppPolicy>,
        },
        {
          path: "/advertisement-disclosure",
          element: <AdvertisementDisclosure></AdvertisementDisclosure>,
        },
        {
          path: "/cash-back-landing",
          element: <CashBackLanding></CashBackLanding>,
        },
        {
          path: "/cash-back-landing/:name",
          element: <PrivateRoute><CashBackLanding></CashBackLanding></PrivateRoute>,
        },
        {
          path: "/cash-back-landing-products/:id",
          element: <PrivateRoute><CashBackLandingForDeals></CashBackLandingForDeals></PrivateRoute>,
        },
        {
          path: "/claim-cash-back",
          element: <ClaimCashback></ClaimCashback>,
        },
        {
          path: "/claim-cash-back/:id",
          element: <DetailsClaimCashBack></DetailsClaimCashBack>,
        },
        {
          path: "/whatsnew",
          element: <WhatsNew></WhatsNew>,
        },
        {
          path: "/whatsnew/:id",
          element: <DetailsWhatsNew></DetailsWhatsNew>,
        },

      ],
    },
    {
      path: '/dashboard',
      element: <PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>,
      children: [
          {
              path: '/dashboard',
              element: <Dashboard></Dashboard>
          },
          {
              path: '/dashboard/appointment',
              element: <Appointment></Appointment>
          },
          {
              path: '/dashboard/purchased-items',
              element: <PurchasedItems></PurchasedItems>
          },
          {
              path: '/dashboard/affiliation',
              element: <Affiliation></Affiliation>
          },
          {
              path: '/dashboard/withdraw',
              element: <Withdraw></Withdraw>
          },
          {
              path: '/dashboard/tickets',
              element: <Tickets></Tickets>
          },
          {
              path: '/dashboard/disputes',
              element: <Disputes></Disputes>
          },
          {
              path: '/dashboard/edit-profile',
              element: <EditProfile></EditProfile>
          },
          {
              path: '/dashboard/reset-password',
              element: <ResetPassword></ResetPassword>
          },
      ]
    }
   
  ]);
  
  export default router;